import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import modalReducer from '../services/modal/reducer'
import authReducer from '../services/auth/reducer'
import vendorsReducer from '../services/vendors/reducer'
import invitationsReducer from '../services/invitations/reducer'
import homeReducer from '../services/home/reducer'
import snackbarReducer from '../services/snackbar/reducer'
import notificationsReducer from '../services/notifications/reducer'
import configReducer from '../services/config/reducer'
import searchesReducer from '../services/searches/reducer'
import procurementReducer from '../services/procurement/reducer'

import vendorDetailsReducer from '../services/vendor-details/reducer'

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    ...modalReducer,
    auth: authReducer,
    vendors: vendorsReducer,
    invitations: invitationsReducer,
    home: homeReducer,
    vendorDetails: vendorDetailsReducer,
    snackbar: snackbarReducer,
    notifications: notificationsReducer,
    config: configReducer,
    searches: searchesReducer,
    procurement: procurementReducer,
  })

export default createRootReducer
